import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import './login.css'
import CryptoJs from 'crypto-js';

const EncryptLogin = (props) => {
    const [userId, setUserId] = useState('');
    const [pwd, setPwd] = useState('');
    const [display, setDisplay] = useState(false);

    const Encryptpassword = () => {
        const user = {
            password: pwd,
            userName: userId
        }
        const secretKey = '_zefdsuh123';
        let pwd1 = CryptoJs.AES.encrypt(pwd, secretKey).toString();

        return <div><h5>userName : {user.userName}</h5>
            <h5>Password : {user.password}</h5>
            <h5>Encrypted Password : {pwd1}</h5></div>;
    };
    return (
        <>
            <div>
                <div className="p-grid">
                    <div className="p-col-12">
                        <span className="encryptlogin">
                            <img src="https://www.ikea.com/gb/en/static/ikea-logo.f7d9229f806b59ec64cb.svg" alt="iFood Logo"
                                height="40" className="p-mr-2" /><h4 className="menubarTextCss">IKEA Trader Data Tool</h4>&nbsp;&nbsp;
                            {/* <TabMenu className="tabCSS" model={itemsOne} activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)} /> */}
                        </span>
                    </div>
                </div>
                <h3>Encryption Password </h3>
                <div className="p-grid p-justify-center p-align-center">

                    <div className="p-col-7 p-md-7 ">
                        <div className="p-fluid">
                            <div className="p-grid">
                                <div className="p-col-7 p-offset-2">
                                    <span className="p-input-icon-right  p-float-label">
                                        <i className="pi pi-user" />
                                        <InputText className="" value={userId} onChange={(e) => setUserId(e.target.value)}
                                        />
                                        <label htmlFor="in">Username</label>

                                    </span>
                                </div>
                            </div>
                            <br></br>
                            <div className="p-grid">
                                <div className="p-col-7 p-offset-2">
                                    <span className="p-input-icon-left p-float-label  ">

                                        <Password className="" feedback={false} value={pwd} onChange={(e) => setPwd(e.target.value)} toggleMask />
                                        <label class="labelText">Password</label>
                                    </span>
                                </div>
                            </div>
                            <div className="p-grid">
                                <div className="p-col-7 p-offset-2">
                                    <Button className="buttonColorOne" label="Submit" icon="pi pi-check"
                                        iconPos="right" onClick={() => setDisplay(!display)} />
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                {display && <div><Encryptpassword /></div>}


            </div>
        </>);

}

export default EncryptLogin;